import { gql } from '@apollo/client';

const GET_ESTIMATE_CALCULATION = gql`
  query orderCalculation($returnDetails: OrderCalculationDetails) {
    orderCalculation(returnDetails: $returnDetails) {
      exchangeAmountFmt
      exchangeItemCount
      itemsRefundFmt
      returnItemCount
      salesTaxRefundFmt
      shippingChargesFmt
      totalRefundFmt
    }
  }
`;

export default GET_ESTIMATE_CALCULATION;
